<template>
    <div class="h-screen flex w-full bg-img" id="page-register">
        <div
            class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center"
        >
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div
                            class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
                        >
                            <img
                                src="@/assets/images/pages/login.png"
                                alt="login"
                                class="mx-auto"
                            />
                        </div>
                        <div
                            class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
                        >
                            <div class="p-8">
                                <div class="vx-card__title mb-2">
                                    <h4 class="mb-4">Сброс пароля</h4>
                                    <!-- <p>Пожалуйста, заполните поля формы.</p> -->
                                </div>
                                <vs-input
                                    name="password"
                                    type="password"
                                    label-placeholder="Новый пароль..."
                                    v-model="form.newPassword"
                                    :danger="!!errors.newPassword"
                                    :danger-text="errors.newPassword"
                                    @keydown.space.prevent
                                    class="w-full no-icon-border"
                                />

                                <vs-input
                                    name="confirmPassword"
                                    type="password"
                                    label-placeholder="Подтверждение нового пароля..."
                                    v-model="form.confirmPassword"
                                    :danger="!!errors.confirmPassword"
                                    :danger-text="errors.confirmPassword"
                                    @keydown.space.prevent
                                    class="w-full no-icon-border"
                                />

                                <div class="mt-6">
                                    <vs-button
                                        @click="sendReset"
                                        color="warning"
                                        class="mr-2"
                                        >Сбросить пароль</vs-button
                                    >
                                    <vs-button @click="backToLogin"
                                        >Отмена</vs-button
                                    >
                                </div>

                                <vs-divider></vs-divider>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                userId: "",
                code: "",
                newPassword: "",
                confirmPassword: "",
            },
            errors: {
                newPassword: "",
                confirmPassword: "",
            },
        };
    },
    methods: {
        sendReset() {
            this.$axios({
                method: "PUT",
                url: "auth/reset_password",
                params: this.form,
                errors: this.errors,
                success: () => {
                    this.$vs.notify({
                        title: "Успешно изменено.",
                        text: "Пароль успешно изменён.",
                        color: "success",
                    });
                    this.backToLogin();
                },
                catch: (err) => {
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при сбросе пароля!",
                        color: "danger",
                    });
                },
            });
        },
        backToLogin() {
            this.$router.push("/login");
        },
    },
    mounted() {
        const query = this.$route.query;
        if (query && query.userId && query.code) {
            this.form.userId = query.userId;
            this.form.code = query.code;
        }
    },
};
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
            background-color: #1551b1;
        }

        .bg-twitter {
            background-color: #00aaff;
        }

        .bg-google {
            background-color: #1551b1;
        }

        .bg-github {
            background-color: #333;
        }
    }
}
</style>
